const options: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false
};

export const DATE_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
};

export const formatDate = (date: Date, formatOptions: Intl.DateTimeFormatOptions = options) => {
  if (!date) {
    return;
  }
  return new Intl.DateTimeFormat('en-GB', formatOptions).format(date);
};

export const addDays = (date: Date, days: number) => {
  if (!date) {
    return;
  }
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const setDate = (date: Date, hours: number, minutes: number) => {
  if (!date) {
    return;
  }
  const newDate = new Date(date);
  newDate.setHours(hours);
  newDate.setMinutes(minutes);
  return newDate;
};

export const formatDateWithTranslation = (
  date: Date,
  t: (key: string) => string,
  formatOptions?: Intl.DateTimeFormatOptions,
  locale?: string
) => {
  if (!date) {
    return '';
  }

  const day = date.getDate();
  const year = date.getFullYear();
  const monthName = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
  const translatedMonth = t(monthName.toLowerCase());

  if (!formatOptions) {
    return `${translatedMonth} ${day}, ${year}`;
  }

  let result = '';

  if (
    formatOptions.month === 'long' &&
    formatOptions.day === 'numeric' &&
    formatOptions.year === 'numeric'
  ) {
    result = `${translatedMonth} ${day}, ${year}`;
  } else if (formatOptions.month === 'long' && formatOptions.day === 'numeric') {
    result = `${translatedMonth} ${day}`;
  } else if (formatOptions.month === 'long' && formatOptions.year === 'numeric') {
    result = `${translatedMonth} ${year}`;
  } else if (formatOptions.month === 'long') {
    result = translatedMonth;
  } else {
    let formattedDate = new Intl.DateTimeFormat(locale || 'en-GB', formatOptions).format(date);

    const englishMonthName = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
    const englishMonthShort = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);

    formattedDate = formattedDate.replace(new RegExp(englishMonthName, 'gi'), translatedMonth);
    formattedDate = formattedDate.replace(new RegExp(englishMonthShort, 'gi'), translatedMonth);

    result = formattedDate;
  }

  return result;
};

export const formatDurationToMinutes = (totalSeconds?: number) => {
  if (!totalSeconds || isNaN(totalSeconds)) {
    return '00:00';
  }
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const formatOptionalDate = (date?: string | Date | null) => {
  if (!date) {
    return 'N/A';
  }
  return formatDate(new Date(date), DATE_FORMAT);
};

export const normalizeOptionalDate = (date?: string | Date | null) => {
  if (!date) {
    return null;
  }

  const parsedDate = new Date(date);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate.toISOString();
};

export const getDaysBetweenDates = (
  startDate?: string | Date | null,
  endDate?: string | Date | null
) => {
  if (!startDate || !endDate) {
    return '-';
  }

  const start = new Date(startDate).getTime();
  const end = new Date(endDate).getTime();

  return Math.ceil((end - start) / (1000 * 60 * 60 * 24)).toString();
};
